const validation = {
  validateValues(values, rules) { 
    for (const [index, item] of values.entries()) {
      const REASON = [];
      for (const key in rules) {
        if (rules[key].length) {
          const rule = rules[key];
          const value = item[key];
          const result = this.validateValue(value, rule);
          if (result.length) {
            REASON.push(result);
          }
        }
      }
      values[index].REASON = REASON.join('、');
    }
    return !values.some((item) => item.REASON);
  },
  validateValue(value, rules) {
    for (const rule of rules) {
      if (Object.keys(rule).length) {
        if(rule.required && ['',null,undefined].includes(value)) return rule.message || 'error';
        if(rule.type === 'number' && isNaN(value)) return rule.message || 'error';
        if(rule.type === 'email' &&!/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+$/.test(value)) return rule.message || 'error';
        if(rule.type === 'phone' &&!/^1[34578]\d{9}$/.test(value)) return rule.message || 'error';
        if(rule.type === 'date' &&!validation.dateValidate(value)) return rule.message || 'error';
        if(rule.type === 'array' && !Array.isArray(value)) return rule.message || 'error';
        if(rule.type === 'object' && typeof value!== 'object') return rule.message || 'error';
        if(rule.type === 'function' && typeof value!== 'function') return rule.message || 'error';
        if(rule.type === 'boolean' && typeof value!== 'boolean') return rule.message || 'error';
        if(rule.type ==='string' && typeof value!=='string') return rule.message || 'error';
        if(rule.type === 'integer' && !/^[0-9]+$/.test(value)) return rule.message || 'error';
        if(rule.type === 'float' && !/^[0-9]+(\.[0-9]+)?$/.test(value)) return rule.message || 'error';
      }
    }
    return '';
  },
  // 价格验证
  价格正数0验证(price) {
    return /^(([1-9]\d*)|(0{1}))(.\d{1,2})?$/.test(price)
  },
  价格正数验证(price) {
    return this.价格正数0验证(price) && Number(price) > 0
  },
  // 数量验证
  数量正负数0验证(count) {
    return /^(([-]?[1-9]\d*)|(0{1}))(.\d+)?$/.test(count)
  },
  数量正负数验证(count) {
    return this.数量正负数0验证(count) && Number(count) != 0
  },
  数量正数0验证(count) {
    return this.数量正负数0验证(count) && Number(count) >= 0
  },
  数量正数验证(count) {
    return this.数量正数0验证(count) && Number(count) > 0
  },
  数量两位小数正数验证(count) {
    return this.数量正数验证(count) && (count.split ('.')[1]?count.split('.')[1].length<=2:true)
  },

  // 整数数量验证
  数量整数正负数0验证(count) {
    return /^(([-]?[1-9]\d*)|(0{1}))(.0+)?$/.test(count)
  },
  数量整数正负数验证(count) {
    return this.数量整数正负数0验证(count) && Number(count) != 0
  },
  数量整数正数0验证(count) {
    return  this.数量整数正负数0验证(count) && Number(count) >= 0
  },
  数量整数正数验证(count) {
    return this.数量整数正数0验证(count) && Number(count) > 0
  },
  产品编码验证(code) {
    return !code || (/^\d+$/.test(code) && code.length >= 10 && code.length <= 16)
  },
  手机号验证(phone) {
    return /^(?:0|86|＋?86)?1[3-9]\d{9}$/.test(phone)
  },
  // yyyy-mm-dd 类型日期验证
  dateValidate(data) {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(data)) {
      return false;
    } else {
      const year = data.split("-")[0]
      const month = data.split("-")[1]
      const date = data.split("-")[2]
      if (year < 2018) {
        return false;
      } else {
        if (['01', '03', '05', '07', '08', '10', '12'].includes(month)) {
          if (date > 31 || date <= 0) {
            return false;
          }
        } else if (['04', '06', '09', '11'].includes(month)) {
          if (date > 30 || date <= 0) {
            return false;
          }
        }
        else if (['02'].includes(month)) {
          if (year % 4 == 0) {
            if (date > 29 || date <= 0) {
              return false;
            } else if (date > 28 || date <= 0) {
              return false;
            }
          }
        } else {
          return false;
        }
      }
      return true;
    }
  },

  日期范围验证([start, end], 天数) {
    return (new Date(end) - new Date(start)) <= 天数 * 24 * 60 * 60 * 1000
  },
  订单ID验证(id) {
    return /^\d+$/.test(id)
  },
  第三方扣点验证(val) {
    return /^[0-9]+(.[0-9]{1,2})?$/.test(val) && Number(val) >= 0 && Number(val) < 100
  }
};
export default validation;



// WEBPACK FOOTER //
// ./src/assets/common/validation.js